import { render, staticRenderFns } from "./accentuatedSlicePie.vue?vue&type=template&id=136d7014&scoped=true"
import script from "./accentuatedSlicePie.vue?vue&type=script&lang=js"
export * from "./accentuatedSlicePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d7014",
  null
  
)

export default component.exports